var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSearchOrange = function SvgSearchOrange(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M57.4474 51.5521L44.9786 39.0833C43.413 41.4062 41.4099 43.4104 39.0859 44.976L51.5547 57.4448C53.1818 59.0719 55.8203 59.0719 57.4474 57.4448C59.0724 55.8229 59.0724 53.1771 57.4474 51.5521Z",
    fill: "#FF7E51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.4,
    d: "M26.9069 5.33331C15.034 5.33331 5.33398 15.0344 5.33398 27C5.33398 38.9656 15.034 48.6666 26.9069 48.6666C38.7798 48.6666 48.5736 38.9656 48.5736 27C48.5736 15.0344 38.9694 5.33331 26.9069 5.33331ZM26.9069 40.3333C19.5548 40.3333 13.5736 34.3521 13.5736 27C13.5736 19.6479 19.5548 13.6666 26.9069 13.6666C34.259 13.6666 40.2403 19.6479 40.2403 27C40.2403 34.3541 34.3548 40.3333 26.9069 40.3333Z",
    fill: "#FF7E51"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearchOrange, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search-orange.c1e26dd3.svg";
export { ForwardRef as ReactComponent };